
document.addEventListener("DOMContentLoaded", function () {
    // Fetch 'locator' key from sessionStorage
    const sessionData = localStorage.getItem("locator");

    if (!sessionData) {
        return; // Exit if session data doesn't exist
    }

    let zoneDetail;
    try {
        zoneDetail = JSON.parse(sessionData);
    } catch (error) {
        console.error("Invalid JSON data in sessionStorage:", error);
        return;
    }

    // Check if zoneDetail is valid
    if (!zoneDetail || typeof zoneDetail !== "object" || !zoneDetail.zone) {
        return;
    }

    // Main condition check
    if (window.productHardinessZones.includes(zoneDetail.zone)) {
        const zoneAvailability = document.querySelector(".custom-product-availability");

        if (zoneAvailability) {
            // if(zoneDetail?.dates?.start == "Anytime"){
            //     const arriveTime = document.querySelectorAll(".arrives-time");
            //     arriveTime.forEach(el => el.classList.add('hide'));
                

            // }else{
            //     const startArriveTime = document.querySelector(".arrives_zone .start_time");
            //     const endArriveTime = document.querySelector(".arrives_zone .end_time");

            //     if (startArriveTime) {
            //         startArriveTime.textContent = zoneDetail.dates.start;
            //     }
            //     if (endArriveTime) {
            //         endArriveTime.textContent = "and " + zoneDetail.dates.end;
            //     }
            //     const arriveTime = document.querySelectorAll(".arrives-time");
            //     arriveTime.forEach(el => el.classList.remove('hide'));
                

            // }
            
            document.querySelector(".loading-skeleton")?.classList.add("hide");
            zoneAvailability.classList.remove("hide");
            document.querySelector(".hardiness_zone_product_explore")?.classList.add("hide");
         //   document.querySelector(".no_hardiness_zone_product")?.classList.add("hide");

        }
    } else {

        if (["1", "2", "12"].includes(zoneDetail.zone)) {
         //   document.querySelector(".no_hardiness_zone_product")?.classList.remove("hide");
            document.querySelector(".hardiness_zone_product_explore")?.classList.add("hide");

        } else {
            const hardinessElement = document.querySelector(".hardiness_modal_link");
            if (hardinessElement) {
                hardinessElement.setAttribute("hardiness_id", zoneDetail.zone);
                hardinessElement.textContent = "Zone " + zoneDetail.zone;
            }
            document.querySelector(".hardiness_zone_product_explore")?.classList.remove("hide");
          //  document.querySelector(".no_hardiness_zone_product")?.classList.add("hide");

        }



        document.querySelector(".loading-skeleton")?.classList.add("hide");
        document.querySelector(".custom-product-availability")?.classList.add("hide");
    }



});
